<template>
  <v-layout align-center justify-center row wrap>
    <v-flex xs12 sm6 md7 v-if="show">
      <h1 class="display-3">Evriday</h1>
      <p class="subheading">Экономьте время для дейсвительно важных задач</p>
    </v-flex>
    <v-flex xs12 sm6 md5>
        <template v-if="!show">
          <h1 class="display-3">Evriday</h1>
          <p class="subheading">Экономьте время для дейсвительно важных задач</p>
        </template>
        <v-card>
          <v-card-title primary-title>
            <div class="headline">Восстановление пароля</div>
          </v-card-title>

          <v-card-text>
            <v-alert class="alert" v-if="errorMessage" color="error" :value="true" >
              {{errorMessage}}
            </v-alert>
            <v-form ref="form" v-model="valid">
              <v-layout row>
                  <v-flex xs3 class="padding5">
                    <v-select
                      v-model="phoneCode"
                      :items="items"
                      :rules="phoneCodeRules"
                      label="Код"
                      required
                      outline
                    ></v-select>
                  </v-flex>
                  <v-flex xs1></v-flex>
                  <v-flex xs8 class="padding5">
                    <v-text-field
                      v-model="phone"
                      :rules="phoneRules"
                      label="Мобильный телефон"
                      required
                      outline
                      clearable
                    ></v-text-field>
                  </v-flex>
                </v-layout>
            </v-form>
          </v-card-text>

          <v-card-actions style="padding: 0 16px;">
            <v-btn block large @click="submit" color="#4169e1" style="color:white">Восстановить пароль</v-btn>
          </v-card-actions>

          <v-card-title style="padding: 16px 16px 0 16px;">
            <!-- <p><a @click="$emit('changeView', 'Registration')">Создать новый аккаунт</a></p> -->
          </v-card-title>
          <v-card-title style="padding: 0 16px;">
            <p><a @click="$emit('changeView', 'Login')">Войти</a></p>
          </v-card-title>
        </v-card>
    </v-flex>
  </v-layout>
</template>

<style scoped>
a:link, a:visited, a:hover, a:active {
  text-decoration: none;
}
</style>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      valid: false,
      phoneCode: '',
      phone: '',
      phoneCodeRules: [],
      phoneRules: [],
      errorMessage: '',
      items: ['+375', '+7']
    }
  },
  props: {
    show: Boolean
  },
  created () {
    this.$store.commit('hideNavigation')
  },
  watch: {
    phoneCode (val) {
      this.phoneCodeRules = []
    },
    phone (val) {
      this.phoneRules = []
    }
  },
  methods: {
    submit: function () {
      this.phoneCodeRules = [
        v => !!v || ''
      ]
      this.phoneRules = [
        v => !!v || 'Необходимо заполнить'
      ]

      let self = this
      setTimeout(function () {
        if (self.$refs.form.validate()) {
          let mobile
          if (self.phoneCode === '+375') {
            mobile = '375' + self.phone// .substring(0, 9)
          } else if (self.phoneCode === '+7') {
            mobile = '7' + self.phone// .substring(0, 10)
          }

          axios.post('/api/forgotPassword', {
            phone: mobile
          })
            .then(response => {
              self.$store.dispatch('showSnackbar', {
                text: 'Новый пароль отправлен вам на телефон',
                color: 'success'
              })
              self.$emit('changeView', 'Login')
            })
            .catch(error => {
              self.errorMessage = error.response.data
            })
        }
      })
    }
  }
}
</script>
